<template>
  <div v-if="member_info">
    <div class="setting-wrap w-940">
      <div class="wrap-title">
        メールアドレスの変更
        <el-button type="info" size="small" style="margin: -5px 0 -5px 20px;" @click="edit_mail = true" v-if="!edit_mail">変更する</el-button>
      </div>
      <div class="setting-subwrap top">
        <div class="setting-subtitle">現在のメールアドレス</div>
        <el-input size="small" v-model="member_info.email" disabled style="margin-bottom:15px"></el-input>
      </div>
      <el-form v-if="edit_mail" :model="newdata" :rules="rules_email" ref="changeEmail" style="width:100%" @submit.native.prevent="changeEmail()">
        <div class="setting-subwrap">
          <div class="setting-subtitle">新しいメールアドレス</div>
          <el-form-item class="setting-form" prop="email">
            <el-input size="small" v-model="newdata.email" autocomplete="off" type="text"></el-input>
          </el-form-item>
        </div>
        <div class="setting-subwrap">
          <div class="setting-subtitle">現在のパスワード</div>
          <el-input size="small" v-model="currentPassword_mail" show-password autocomplete="new-password" style="margin-bottom:15px"></el-input>
        </div>
        <div class="divider-nomargin"></div>
        <div class="flex-row">
          <el-button type="primary" size="small" native-type="submit" :disabled="loading_email">
            <div class="flex-row">
              変更を保存
              <div class="loader--mini" v-show="loading_email"></div>
            </div>
          </el-button>
          <el-button size="small" style="margin-left: 10px;" @click="edit_mail = false">キャンセル</el-button>
        </div>
      </el-form>
    </div>
    <div class="setting-wrap w-940">
      <div class="wrap-title">
        パスワードの変更
        <el-button type="info" size="small" style="margin: -5px 0 -5px 20px;" @click="edit_password = true" v-if="!edit_password">変更する</el-button>
      </div>
      <el-form v-if="edit_password" :model="newdata" :rules="rules_password" ref="changePassword" style="width:100%" @submit.native.prevent="changePassword()">
        <div class="setting-subwrap top">
          <div class="setting-subtitle">現在のパスワード</div>
          <el-input size="small" v-model="currentPassword_pass" autocomplete="new-password" show-password style="margin-bottom:15px"></el-input>
        </div>
        <div class="setting-subwrap">
          <div class="setting-subtitle">新しいパスワード</div>
          <el-form-item class="setting-form" prop="pass">
            <el-input size="small" v-model="newdata.pass" autocomplete="new-password" show-password></el-input>
          </el-form-item>
        </div>
        <div class="setting-subwrap">
          <div class="setting-subtitle">新しいパスワード(再入力)</div>
          <el-form-item class="setting-form" prop="checkPass">
            <el-input size="small" v-model="newdata.checkPass" autocomplete="new-password" show-password></el-input>
          </el-form-item>
        </div>
        <div class="divider-nomargin"></div>
        <div class="flex-row">
          <el-button type="primary" size="small" native-type="submit" :disabled="loading_pass">
            <div class="flex-row">
              変更を保存
              <div class="loader--mini" v-show="loading_pass"></div>
            </div>
          </el-button>
          <el-button size="small" style="margin-left: 10px;" @click="edit_password = false">キャンセル</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/compat/app";
const root = process.env.VUE_APP_API;
const changeEmailAPI = root + "/api/auth/change_email";
const changePasswordAPI = root + "/api/auth/change_password";
const emailValidateAPI = root + "/api/auth/emailvalidate";
const emailVerificationAPI = root + "/api/auth/email_verification";

var freeEmail =
  "/msn.com$|gmail.com$|hotmail.co.jp$|hotmail.com$|yahoo.co.jp$|mail.goo.ne.jp$|freemail.ne.jp$|tokyo24.com$|excite.co.jp$|infoseek.co.jp$|infoseek.jp$|comeon.to$|comeon.cx$|cuib.or.jp$|ziplip.co.jp$|zdnetmail.ne.jp$|supermail.com$|lycos.ne.jp$|lycos.com$|clubaa.com$|prontomail.ne.jp$|itpmail.itp.ne.jp$|bizoffi.com$|xaque.com$|safe-mail.ne.jp$|100100.co.jp$|mailkun.com$|curio-city.com$|teamgear.net$|24h.co.jp$|gariya.net$|pub.ne.jp$|jmail.co.jp$|kigaru.zzn.com$|goomail.com$|iloveyou-jp.com$|wbs-club.ne.jp$|otegami.com$|piyomail.com$|iat.ne.jp$|aol.com$|tok2.com$|kobe-city.com$|xmail.to$|club.wonder.ne.jp$|pub.to$|csc.ne.jp$|club.ne.jp$|mcn.ne.jp$|postpet.co.jp$|manbow.com$|ijk.com$|drive.co.jp$|yagi.net$|pospe.jp.prg$|estyle.ne.jp$|eastmail.com$|shagami.com$|voo.to$|julex.to$|yi-web.com$|mailfriend.net$|koei.nu$|goo.jp$|kobej.zzn.com$|pc_run.zzn.com$|fact-mail.com$|walkerplus.com$|keyakiclub.net$|yesyes.jp$|fubako.com$|smoug.net$|meritmail.net$|vjp.jp$|melmel.tv$|ultrapostman.com$|uymail.com$|sailormoon.com$|astroboymail.com$|doramail.com$|dbzmail.com$|aamail.jp$|lunashine.net$|gooo.jp$|1kw.jp$|hsjp.net$|glaystyle.net$|saku2.com$|kyouin.com$|Netidol.jp$|csc.jp$|kanagawa.to$|mukae.com$|anet.ne.jp$|docomo.ne.jp$|softbank.ne.jp$|i.softbank.jp$|disney.ne.jp$|d.vodafone.ne.jp$|h.vodafone.ne.jp$|t.vodafone.ne.jp$|c.vodafone.ne.jp$|r.vodafone.ne.jp$|k.vodafone.ne.jp$|n.vodafone.ne.jp$|s.vodafone.ne.jp$|q.vodafone.ne.jp$|jp-d.ne.jp$|jp-h.ne.jp$|jp-t.ne.jp$|jp-c.ne.jp$|jp-c.ne.jp$|jp-k.ne.jp$|jp-n.ne.jp$|jp-s.ne.jp$|jp-q.ne.jp$|ezweb.ne.jp$|au.com$|biz.ezweb.ne.jp$|ido.ne.jp$|sky.tkk.ne.jp$|sky.tkc.ne.jp$|sky.tu-ka.ne.jp$|pdx.ne.jp$|di.pdx.ne.jp$|dj.pdx.ne.jp$|dk.pdx.ne.jp$|wm.pdx.ne.jp$|willcom.com$|emnet.ne.jp$/";

export default {
  name: "EmailandPassword",
  props: ["member_info"],
  data() {
    var validateEmail = (rule, value, callback) => {
      var freeCheck = value.match(freeEmail);
      if (freeCheck) {
        callback(new Error("フリーアドレスはご利用いただけません"));
      } else {
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("パスワードは必須です"));
      } else {
        if (this.newdata.checkPass !== "") {
          this.$refs.changePassword.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("パスワード(再入力)は必須です"));
      } else if (value !== this.newdata.pass) {
        callback(new Error("パスワードが一致しません"));
      } else {
        callback();
      }
    };
    return {
      edit_mail: false,
      edit_password: false,
      newdata: {
        email: "",
        pass: "",
        checkPass: "",
      },
      loading_email: false,
      loading_pass: false,
      currentPassword_mail: "",
      currentPassword_pass: "",
      rules_email: {
        email: [
          {
            required: true,
            message: "メールアドレスは必須です",
            trigger: "blur",
          },
          { validator: validateEmail, trigger: "blur" },
        ],
      },
      rules_password: {
        pass: [
          { required: true, message: "パスワードは必須です", trigger: "blur" },
          {
            min: 8,
            message: "パスワードは8文字以上で設定してください",
            trigger: "blur",
          },
          { validator: validatePass, trigger: "blur" },
        ],
        checkPass: [{ validator: validatePass2, trigger: "blur" }],
      },
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    user_token() {
      return this.$store.state.user_token;
    },
  },
  mounted() {},
  methods: {
    changeEmail() {
      this.loading_email = true;
      this.$refs["changeEmail"].validate((valid) => {
        if (valid) {
          //二重登録チェック
          var params = new URLSearchParams();
          params.append("email", this.newdata.email);
          params.append("pass", this.currentPassword_mail);
          params.append("token", this.token);
          params.append("user_token", this.user_token);
          params.append("type", "change_email");
          this.axios.post(emailValidateAPI, params).then((response) => {
            if (response.data.status == "NG") {
              this.loading_email = false;
              this.$message({
                type: "error",
                offset: 7,
                showClose: true,
                message: response.data.message,
              });
            } else {
              this.$confirm(this.newdata.email + "に認証メールを送信します", "メールアドレス変更", {
                distinguishCancelAndClose: true,
                type: "info",
                confirmButtonText: "送信",
                cancelButtonText: "キャンセル",
              }).then(() => {
                //database、firebaseのデータ更新・認証メールの送信
                var params = new URLSearchParams();
                params.append("email", this.newdata.email);
                params.append("user_token", this.user_token);
                this.axios.post(changeEmailAPI, params).then((response) => {
                  if (response.data.status == "OK") {
                    this.$store.dispatch("getUserData", { token: this.token, user_token: this.user_token });
                    this.loading_email = false;
                    this.$message({
                      type: "success",
                      offset: 7,
                      showClose: true,
                      message: "認証メールを送信しました",
                    });
                  } else {
                    this.loading_email = false;
                    this.$message({
                      type: "error",
                      offset: 7,
                      showClose: true,
                      message: "エラーが発生しました。しばらく時間を空けてお試しいただくか、担当者までご連絡ください。",
                    });
                  }
                });
              })
              .catch(() => {
                this.loading_email = false;
              });
            }
          });
        } else {
          this.loading_email = false;
          this.$message({
            type: "error",
            offset: 7,
            showClose: true,
            message: "新しいメールアドレスを正しく入力してください",
          });
        }
      });
    },
    changePassword() {
      this.loading_pass = true;
      const credential = firebase.auth.EmailAuthProvider.credential(this.member_info.email, this.currentPassword_pass);
      firebase
        .auth()
        .currentUser.reauthenticateWithCredential(credential)
        .then(() => {
          // 再認証に成功した場合のみ、メソッドを実行する
          this.$refs["changePassword"].validate((valid) => {
            if (valid) {
              firebase
                .auth()
                .currentUser.updatePassword(this.newdata.pass)
                .then(() => {
                  var params = new URLSearchParams();
                  params.append("pass", this.newdata.pass);
                  params.append("uid", this.user_token);
                  this.axios.post(changePasswordAPI, params)
                    .then(() => {
                      this.loading_pass = false;
                      this.$message({
                        type: "success",
                        offset: 7,
                        showClose: true,
                        message: "パスワードを変更しました。",
                      });
                      this.newdata = [];
                      this.currentPassword_pass = "";
                    })
                    .catch(() => {
                      this.loading_pass = false;
                      this.$message.error("パスワードの変更に失敗しました。");
                    });
                })
                .catch(() => {
                  this.loading_pass = false;
                  this.$message({
                    type: "error",
                    offset: 7,
                    message: "パスワードが脆弱すぎるかパスワードリセットの有効期限が切れています",
                  });
                });
            } else {
              this.loading_pass = false;
              this.$message({
                type: "error",
                showClose: true,
                message: "新しいパスワードを正しく入力してください",
              });
            }
          });
        })
        .catch((error) => {
          console.log(error);
          this.$message({
            type: "error",
            offset: 7,
            showClose: true,
            message: "現在のパスワードが違います",
          });
          this.loading_email = false;
          this.loading_pass = false;
        });
    },
  },
  watch: {},
  filters: {},
};
</script>
